import { Plugin } from '@nuxt/types';
import Service from '@root/common/base/Service';

import { InstanceConnector } from '@ekd/portal-connector/dist/InstanceConnector';

import { PaywallInstance } from '@paywall/plugins/PaywallInstance';
import { CustomerInstance } from '@customer/plugins/CustomerInstance';
import { HeadlinesInstance } from '@headlines/plugins/HeadlinesInstance';
import { RootInstance } from './RootInstance';

const instanceConnector: Plugin = (ctx, inject) => {
  const instanceConnector = new InstanceConnector({ type: 'Nuxt' });
  const instance = instanceConnector
    .addContext({ store: ctx.store, $eventHandler: ctx.app.$eventHandler, service: new Service() })
    .addLibrary([new RootInstance(), new PaywallInstance(), new CustomerInstance(), new HeadlinesInstance()])
    .connect();

  inject('instanceConnector', instance.install());
};

export default instanceConnector;
